import { render, staticRenderFns } from "./EstimatedResults.vue?vue&type=template&id=06932662&"
import script from "./EstimatedResults.vue?vue&type=script&lang=js&"
export * from "./EstimatedResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports